<template>
    <div class="sideBar">
        <el-menu class="el-menu-vertical-demo menu" style="border: 0px" :default-active="activeNav"
                 background-color="#3D6DA8" text-color="#fff" theme="dark" @select="handleSelect" router>
            <template v-for="item in routeJson">
                <template v-if="item.subs" style="padding-left: 30px">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title" style="padding-left: 30px">
                            <i class="el-icon-location"></i>
                            <span>{{item.title}}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="(threeItem,i) in item.subs" :key="i" :index="'/home/'+threeItem.index">
                                <i :class="'fa '+threeItem.icon+' icon'"></i>
                                <span>{{threeItem.title}}</span>
                            </el-menu-item>
                        </el-menu-item-group> 
                    </el-submenu> 
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="'fa '+item.icon+' icon'" aria-hidden="true"></i>{{ item.title }}
                    </el-menu-item>
                </template>
            </template>

            <!-- <el-menu-item index="/home/chapterManagement">
                <i class="fa fa-dot-circle-o icon" aria-hidden="true"></i>用章管理
            </el-menu-item> -->
            <!-- <el-menu-item index="/home/performance">
                <i class="fa fa-user-circle-o icon" aria-hidden="true"></i>绩效管理
            </el-menu-item> -->
            <!-- <el-menu-item index="/home/hello">
                <i class="fa fa-home icon" aria-hidden="true"></i>首页
            </el-menu-item>
            <el-menu-item index="/home/arrange">
                <i class="fa fa-calendar icon" aria-hidden="true"></i>排班
            </el-menu-item>
            <el-submenu index="/home/reservation">
                <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>预约</span>
                </template>
                <el-menu-item-group>
                    <template slot="title">二级菜单列</template>
                    <el-menu-item index="/home/reservation/Mrliu/Visdoctor">
                        <i class="fa fa-dashcube icon"></i>
                        <span>今日预约</span>
                    </el-menu-item>
                    <el-menu-item index="/home/conventionList">
                        <i class="fa fa-heartbeat icon"></i>
                        <span>预约详情</span>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="/home/inquiryList">
                <i class="fa fa-plus-square icon" aria-hidden="true"></i>问诊
            </el-menu-item>
            <el-menu-item index="/home/project">
                <i class="fa fa-folder-open-o icon" aria-hidden="true"></i>组方
            </el-menu-item> -->
        </el-menu>
        <!--  -->
        <topBars class="topbar" v-on:changePassword="changePassword"></topBars>
        <!-- 当前位置 -->
        <!-- <Levelbar class="breadcrumb1"></Levelbar> -->

        <!-- 修改密码 -->
        <el-dialog modal center title="提示" :visible.sync="dialogVisible" width="30%"
                   :before-close="handleClose">
            <div>输入新密码：
                <el-input type="text" v-model="password"></el-input>
            </div>
            <br>
            <div>确认新密码：
                <el-input type="text" v-model="passwordvalue"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
             <el-button @click="dialogVisible = false">取 消</el-button>
             <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 组件元素 -->
        <router-view class="content"></router-view>
    </div>

</template>
<style  >
    /*左边的导航条*/
    .el-menu-item-group__title{
        padding: 0;
    }

    .sideBar .menu{
        overflow-y: auto;
        overflow-x: hidden;
    }

    .el-submenu [class^=el-icon-] {
        vertical-align: middle;
        margin-right: 15px;
        width: 24px;
        text-indent: 13px;
        font-size: 18px;
    }
    .el-submenu__title i {
        color: white;
    }
    .sideBar .menu {
        width: 200px;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
    }
    .el-menu-item i{
        color: white;
    }
    /* .menu::-webkit-scrollbar {
        width: 5px;     
        height: 1px;
    }
    .menu::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color:#1E90FF; 
        background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);
    }
    .menu::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: #EDEDED;
    } */


    .sideBar .menu a {
        color: #bfcbd9;
        text-decoration: none;
    }

    .sideBar a.router-link-active {
        color: #20a0ff;
        text-decoration: none;
    }

    /*导航条图标*/
    .sideBar .icon {
        padding-left: 15px;
        padding-right: 15px;
    }

    /*路由内容*/
    .sideBar .content {
        margin-left: 200px;
    }

    /*头顶的导航*/
    .sideBar .topbar {
        clear: both;
        padding: 0;
        margin-top: 0;
        margin-left: 200px;
    }

    .sideBar .breadcrumb1 {
        clear: both;
        padding: 15px;
        margin-left: 200px;
        font-size: 18px;
    }

</style>
<script>
  import TopBars from '@/view/NavBar/topBars';
  import Levelbar from '@/view/NavBar/Levelbar';

  export default {
    components: {
      topBars: TopBars,
      Levelbar,
    },
    data() {
      return {
        sClass: true,
        password: '',
        passwordvalue: '',
        dialogVisible: false,
        routeJson: []
      }
    },
    methods: {

      changePassword: function (changePassword) {
        this.dialogVisible = changePassword
      },
      submit: function () {
        let id = localStorage.uid;
          let password={password:this.password}
          if (this.password=='') {
              this.$alert('密码不能为空')
              return false
          }
          if ( this.password===this.passwordvalue) {
          this.$axios({
              url:'/api/user/modifyPassword/'+id,
              method: 'PUT',
              params:password
          }).then(res=>{
              if (res.data.code==200){
                  this.$message({
                      type:'success',
                      message:'密码修改成功'
                  })
              }
          }).catch(err=>{
              console.log(err.data);
          })
          }else {
              this.$alert('两次密码输入不一致')
          }
          this.password='';
          this.passwordvalue='';
        this.dialogVisible = false;
      },
      handleSelect(key, keyPath) {
        this.activeNav = key;
      },
      handleClose(done) {
        this.$confirm('确认关闭？').then(_ => {
          done();
        }).catch(_ => {
        });
      },
      updateRouter(rid) {
        this.$axios({
          url: '/api/permission/userId/' + rid,
          method: 'GET'
        }).then(res => {
          let routerJson = res.data.data;
          for (let i = 0; i < routerJson.length; i++) {
            if (routerJson[i].title == '预约') {
              routerJson[i].subs = [
                {
                  index: 'reservation/Mrliu/Visdoctor',
                  title: '今日预约',
                  icon: 'fa-clock-o',
                },
                {
                  index: 'menu/conventionList',
                  title: '预约详情',
                  icon: 'fa-clock-o',
                }
              ]
            }
          }
          this.routeJson = routerJson;
        }).catch(err => {
          console.log(err);
        });
      }
    },
    created: function () {
      let reg = /(\/home\/[a-zA-Z0-9]+)/ig;
      let uid = localStorage.uid;
      let path = this.$route.path;
      if (uid != undefined) {
        this.updateRouter(uid);
      } else {
        this.$message({
          type: 'success',
          message: '请重新登录'
        })
      }
      if (path == '/home/reservation/Mrliu/Visdoctor') {
        this.activeNav = path;
      } else {
        let arr = path.match(reg);
        this.activeNav = arr[0];
      }
    },
  }
</script>



// WEBPACK FOOTER //
// home.vue?bb25eec2